/*
 *
 * SignupParent reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_SIGNUPPARENT,
  LOAD_SIGNUPPARENT,
  LOAD_SIGNUPPARENT_SUCCESS,
  LOAD_SIGNUPPARENT_ERROR,
  CHANGE_SIGNUPPARENT,
  CHANGE_SIGNUPPARENT_SUCCESS,
  CHANGE_SIGNUPPARENT_ERROR,
  DELETE_SIGNUPPARENT,
  DELETE_SIGNUPPARENT_SUCCESS,
  DELETE_SIGNUPPARENT_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  deleteSuccessful: false,
  signupParentList: false,
  signupParentData: false,
};

/* eslint-disable default-case, no-param-reassign */
const signupParentReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_SIGNUPPARENT:
        return initialState;

      // LOAD
      case LOAD_SIGNUPPARENT:
        draft.loading = true;
        draft.error = false;
        break;

      case LOAD_SIGNUPPARENT_SUCCESS:
        draft.signupParentList = action.signupParentList;
        draft.loading = false;
        break;

      case LOAD_SIGNUPPARENT_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // CHANGE/UPDATE
      case CHANGE_SIGNUPPARENT:
        draft.signupParentData = {
          ...state.signupParentData,
          ...action.signupParentData,
        };
        draft.loading = true;
        draft.error = false;
        break;

      case CHANGE_SIGNUPPARENT_SUCCESS:
        draft.loading = false;
        const { signupParentData } = action;
        draft.signupParentData = signupParentData;

        // update single item in the list inside state
        let listData = draft.signupParentList.data;
        let index = draft.signupParentList.data.findIndex(
          po => po._id === signupParentData._id,
        );
        index !== -1
          ? (listData[index] = signupParentData)
          : listData.unshift(signupParentData);
        draft.signupParentList = { ...draft.signupParentList, data: listData };

        break;

      case CHANGE_SIGNUPPARENT_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // DELETE
      case DELETE_SIGNUPPARENT:
        draft.loading = true;
        draft.id = action.id;
        break;

      case DELETE_SIGNUPPARENT_SUCCESS:
        draft.loading = false;
        draft.deleteSuccessful = true;
        break;
    }
  });

export default signupParentReducer;
